import { render, staticRenderFns } from "./StepSign.vue?vue&type=template&id=458a2b38&scoped=true"
import script from "./StepSign.vue?vue&type=script&lang=js"
export * from "./StepSign.vue?vue&type=script&lang=js"
import style0 from "./StepSign.vue?vue&type=style&index=0&id=458a2b38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458a2b38",
  null
  
)

export default component.exports